/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get dashboards.
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {string} [distribution] 
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsChatsRatings: async (fromDate: string, toDate: string, distribution?: string, agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('reportsChatsRatings', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('reportsChatsRatings', 'toDate', toDate)
            const localVarPath = `/api/v1/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['from_date'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['to_date'] = toDate;
            }

            if (distribution !== undefined) {
                localVarQueryParameter['distribution'] = distribution;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get dashboards.
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {string} [distribution] 
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsChatsRatings(fromDate: string, toDate: string, distribution?: string, agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsChatsRatings(fromDate, toDate, distribution, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.reportsChatsRatings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary Get dashboards.
         * @param {DashboardApiReportsChatsRatingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsChatsRatings(requestParameters: DashboardApiReportsChatsRatingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.reportsChatsRatings(requestParameters.fromDate, requestParameters.toDate, requestParameters.distribution, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reportsChatsRatings operation in DashboardApi.
 * @export
 * @interface DashboardApiReportsChatsRatingsRequest
 */
export interface DashboardApiReportsChatsRatingsRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardApiReportsChatsRatings
     */
    readonly fromDate: string

    /**
     * 
     * @type {string}
     * @memberof DashboardApiReportsChatsRatings
     */
    readonly toDate: string

    /**
     * 
     * @type {string}
     * @memberof DashboardApiReportsChatsRatings
     */
    readonly distribution?: string

    /**
     * 
     * @type {string}
     * @memberof DashboardApiReportsChatsRatings
     */
    readonly agentId?: string | null
}

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @summary Get dashboards.
     * @param {DashboardApiReportsChatsRatingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public reportsChatsRatings(requestParameters: DashboardApiReportsChatsRatingsRequest, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).reportsChatsRatings(requestParameters.fromDate, requestParameters.toDate, requestParameters.distribution, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }
}

